const THEMES = [
  {
    id: 'default',
    name: 'GigRequest',
    primary: '#667eea', secondary: '#764ba2', background: '#ffffff', text: '#333333',
    surface: '#ffffff', surfaceAlt: '#f8f9fa', border: '#e2e8f0',
    textSecondary: '#666666', textMuted: '#999999',
    navGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    onPrimary: '#ffffff', isDark: false,
  },
  {
    id: 'classic-rock',
    name: 'Classic Rock',
    primary: '#f67280', secondary: '#764ba2', background: '#2d2d2d', text: '#ffffff',
    surface: '#3a3a3a', surfaceAlt: '#444444', border: 'rgba(255,255,255,0.12)',
    textSecondary: 'rgba(255,255,255,0.6)', textMuted: 'rgba(255,255,255,0.32)',
    navGradient: 'linear-gradient(135deg, #764ba2 0%, #f67280 100%)',
    onPrimary: '#ffffff', isDark: true,
  },
  {
    id: 'blues-jazz',
    name: 'Blues & Jazz',
    primary: '#2c3e50', secondary: '#f39c12', background: '#ecf0f1', text: '#34495e',
    surface: '#ffffff', surfaceAlt: '#f5f5f5', border: '#d8dee4',
    textSecondary: '#666666', textMuted: '#999999',
    navGradient: 'linear-gradient(135deg, #2c3e50 0%, #f39c12 100%)',
    onPrimary: '#ffffff', isDark: false,
  },
  {
    id: 'country-folk',
    name: 'Country & Folk',
    primary: '#8b4513', secondary: '#daa520', background: '#f5f5dc', text: '#4a4a4a',
    surface: '#fdfcf4', surfaceAlt: '#f0ede0', border: '#d4c89a',
    textSecondary: '#6b6b4f', textMuted: '#9a9a7f',
    navGradient: 'linear-gradient(135deg, #8b4513 0%, #daa520 100%)',
    onPrimary: '#ffffff', isDark: false,
  },
  {
    id: 'pop-dance',
    name: 'Pop & Dance',
    primary: '#ff1493', secondary: '#00bfff', background: '#ffffff', text: '#000000',
    surface: '#ffffff', surfaceAlt: '#f8f8f8', border: '#e0e0e0',
    textSecondary: '#555555', textMuted: '#999999',
    navGradient: 'linear-gradient(135deg, #ff1493 0%, #00bfff 100%)',
    onPrimary: '#ffffff', isDark: false,
  },
  {
    id: 'metal',
    name: 'Metal',
    primary: '#cc2200', secondary: '#708090', background: '#111111', text: '#ffffff',
    surface: '#1e1e1e', surfaceAlt: '#252525', border: 'rgba(255,255,255,0.1)',
    textSecondary: 'rgba(255,255,255,0.55)', textMuted: 'rgba(255,255,255,0.3)',
    navGradient: 'linear-gradient(135deg, #8b0000 0%, #708090 100%)',
    onPrimary: '#ffffff', isDark: true,
  },
  {
    id: 'amber-dark',
    name: 'Amber Dark',
    primary: '#F59E0B', secondary: '#D97706', background: '#0D0800', text: '#ffffff',
    surface: '#1A1200', surfaceAlt: '#231800', border: 'rgba(245,158,11,0.22)',
    textSecondary: 'rgba(255,255,255,0.52)', textMuted: 'rgba(255,255,255,0.28)',
    navGradient: 'linear-gradient(135deg, #C17B10 0%, #8B4E00 100%)',
    onPrimary: '#0D0800', isDark: true,
  },
  {
    id: 'custom',
    name: 'Custom',
    primary: '#667eea', secondary: '#764ba2', background: '#ffffff', text: '#333333',
    surface: '#ffffff', surfaceAlt: '#f8f9fa', border: '#e2e8f0',
    textSecondary: '#666666', textMuted: '#999999',
    navGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    onPrimary: '#ffffff', isDark: false,
  },
];

export function resolveTheme(settings) {
  const themeName = settings?.theme_name || 'default';
  const base = THEMES.find(t => t.id === themeName) || THEMES[0];

  if (themeName === 'custom') {
    const primary    = settings.primary_color    || '#667eea';
    const secondary  = settings.secondary_color  || '#764ba2';
    const background = settings.background_color || '#ffffff';
    const text       = settings.text_color       || '#333333';
    const hex = background.replace('#', '');
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    const isDark = (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.5;
    return {
      ...base, primary, secondary, background, text,
      navGradient: `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)`,
      isDark,
      surface:       isDark ? '#1e1e1e'                   : '#ffffff',
      surfaceAlt:    isDark ? '#252525'                   : '#f8f9fa',
      border:        isDark ? 'rgba(255,255,255,0.1)'     : '#e2e8f0',
      textSecondary: isDark ? 'rgba(255,255,255,0.55)'    : '#666',
      textMuted:     isDark ? 'rgba(255,255,255,0.3)'     : '#999',
      onPrimary:     isDark ? background                  : '#ffffff',
    };
  }

  return base;
}

export default THEMES;
